
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/[serviceSlug]/content-hub",
      function () {
        return require("private-next-pages/services/[serviceSlug]/content-hub/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/[serviceSlug]/content-hub"])
      });
    }
  